import * as actionTypes from "./actionTypes";

export const loadUserList = data => {
  return {
    type: actionTypes.LOAD_USER_LIST,
    data
  };
};

export const loadUserListSuccess = data => {
  return {
    type: actionTypes.LOAD_USER_LIST_SUCCESS,
    data
  };
};

export const loadUserListFail = () => {
  return {
    type: actionTypes.LOAD_USER_LIST_FAIL
  };
};


export const loadUserFilter = data => {
  
  return {
    type: actionTypes.LOAD_USER_FILTER,
    data
  };
};

export const loadUserFilterSuccess = data => {
  return {
    type: actionTypes.LOAD_USER_FILTER_SUCCESS,
    data
  };
};

export const loadUserFilterFail = () => {
  return {
    type: actionTypes.LOAD_USER_FILTER_FAIL
  };
};


export const editUserDetail = (id,data) => {
  return {
    type: actionTypes.EDIT_USER_DETAIL,
    id,
    data
  };
};

export const editUserDetailSuccess = () => {
  return {
    type: actionTypes.EDIT_USER_DETAIL_SUCCESS
  };
};

export const editUserDetailFail = () => {
  return {
    type: actionTypes.EDIT_USER_DETAIL_FAIL
  };
};



export const removeUser = (id, data) => {
  return {
    type: actionTypes.REMOVE_USER,
    id,
    data
  };
};

export const removeUserSuccess = () => {
  return {
    type: actionTypes.REMOVE_USER_SUCCESS
  };
};

export const removeUserFail = () => {
  return {
    type: actionTypes.REMOVE_USER_FAIL
  };
};


export const recoveryUser = (id, data) => {
  
  return {
    type: actionTypes.RECOVERY_USER,
    id,
    data
  };
};

export const recoveryUserSuccess = () => {
  
  return {
    type: actionTypes.RECOVERY_USER_SUCCESS
  };
};

export const recoveryUserFail = () => {
  return {
    type: actionTypes.RECOVERY_USER_FAIL
  };
};


export const editUserStatus = (id,data, listParams = null) => {
  return {
    type: actionTypes.EDIT_USER_STATUS,
    id,
    data,
    listParams
  };
};

export const editUserStatusSuccess = () => {
  return {
    type: actionTypes.EDIT_USER_STATUS_SUCCESS
  };
};

export const editUserStatusFail = () => {
  return {
    type: actionTypes.EDIT_USER_STATUS_FAIL
  };
};



export const editUserLoginShowVeriCodeStatus = (id,data, listParams) => {
  return {
    type: actionTypes.EDIT_USER_SHOW_VERI_CODE_STATUS,
    id,
    data,
    listParams
  };
};

export const editUserLoginShowVeriCodeStatusSuccess = () => {
  return {
    type: actionTypes.EDIT_USER_SHOW_VERI_CODE_STATUS_SUCCESS
  };
};

export const editUserLoginShowVeriCodeStatusFail = () => {
  return {
    type: actionTypes.EDIT_USER_SHOW_VERI_CODE_STATUS_FAIL
  };
};


export const editUserGroupBonusStatus = (id,data, listParams) => {
  return {
    type: actionTypes.EDIT_USER_GROUP_BONUS_STATUS,
    id,
    data,
    listParams
  };
};

export const editUserGroupBonusStatusSuccess = () => {
  return {
    type: actionTypes.EDIT_USER_GROUP_BONUS_STATUS_SUCCESS
  };
};

export const editUserGroupBonusStatusFail = () => {
  return {
    type: actionTypes.EDIT_USER_GROUP_BONUS_STATUS_FAIL
  };
};



export const editUserVerifyStatus = (id,data, listParams) => {
  return {
    type: actionTypes.EDIT_USER_VERIFY_STATUS,
    id,
    data,
    listParams
  };
};

export const editUserVerifyStatusSuccess = () => {
  return {
    type: actionTypes.EDIT_USER_VERIFY_STATUS_SUCCESS
  };
};

export const editUserVerifyStatusFail = () => {
  return {
    type: actionTypes.EDIT_USER_VERIFY_STATUS_FAIL
  };
};

export const loadUserDetail = (id, data) => {
  
  return {
    type: actionTypes.LOAD_USER_DETAIL,
    id,
    data
  };
};

export const loadUserDetailSuccess = data => {
  
  return {
    type: actionTypes.LOAD_USER_DETAIL_SUCCESS,
    data
  };
};

export const loadUserDetailFail = () => {
  return {
    type: actionTypes.LOAD_USER_DETAIL_FAIL
  };
};

export const switchUserToOrganizationType = (id, data) => {
  
  return {
    type: actionTypes.SWITCH_USER_TO_ORGANIZATION_TYPE,
    id,
    data
  };
};

export const switchUserToOrganizationTypeSuccess = () => {
  
  return {
    type: actionTypes.SWITCH_USER_TO_ORGANIZATION_TYPE_SUCCESS
  };
};

export const switchUserToOrganizationTypeFail = () => {
  return {
    type: actionTypes.SWITCH_USER_TO_ORGANIZATION_TYPE_FAIL
  };
};



export const userCount = (data) => {
  
  return {
    type: actionTypes.USER_COUNT,
    data
  };
};

export const userCountSuccess = data => {
  return {
    type: actionTypes.USER_COUNT_SUCCESS,
    data
  };
};

export const userCountFail = () => {
  return {
    type: actionTypes.USER_COUNT_FAIL
  };
};

/* ===== USER SUMMARY ===== */
export const loadUserSummary = data => {
  return {
    type: actionTypes.LOAD_USER_SUMMARY,
    data
  };
};

export const loadUserSummarySuccess = data => {
  return {
    type: actionTypes.LOAD_USER_SUMMARY_SUCCESS,
    data
  };
};

export const loadUserSummaryFail = () => {
  return {
    type: actionTypes.LOAD_USER_SUMMARY_FAIL
  };
};

/* ===== END USER SUMMARY ===== */




/* ===== USER BILLING ADDRESS ===== */
export const setUserBillingAddress = (id,data) => {
  return {
    type: actionTypes.SET_USER_BILLING_ADDRESS,
    id,
    data
  };
};

export const setUserBillingAddressSuccess = () => {
  return {
    type: actionTypes.SET_USER_BILLING_ADDRESS_SUCCESS
  };
};

export const setUserBillingAddressFail = () => {
  return {
    type: actionTypes.SET_USER_BILLING_ADDRESS_FAIL
  };
};

/* ===== END USER BILLING ADDRESS ===== */


export const loadUserDeviceList = data => {
  
  return {
    type: actionTypes.LOAD_USER_DEVICE_LIST,
    data
  };
};

export const loadUserDeviceListSuccess = data => {
  return {
    type: actionTypes.LOAD_USER_DEVICE_LIST_SUCCESS,
    data
  };
};

export const loadUserDeviceListFail = () => {
  return {
    type: actionTypes.LOAD_USER_DEVICE_LIST_FAIL
  };
};

export const logoutUserDevice = (id,data) => {
  return {
    type: actionTypes.LOGOUT_USER_DEVICE,
    id,
    data
  };
};

export const logoutUserDeviceSuccess = (data) => {
  return {
    type: actionTypes.LOGOUT_USER_DEVICE_SUCCESS,
    data
  };
};

export const logoutUserDeviceFail = () => {
  return {
    type: actionTypes.LOGOUT_USER_DEVICE_FAIL
  };
};


export const removeUserDevice = (id, data) => {
  
  return {
    type: actionTypes.REMOVE_USER_DEVICE,
    id,
    data
  };
};

export const removeUserDeviceSuccess = () => {
  
  return {
    type: actionTypes.REMOVE_USER_DEVICE_SUCCESS
  };
};

export const removeUserDeviceFail = () => {
  return {
    type: actionTypes.REMOVE_USER_DEVICE_FAIL
  };
};


export const devModeUserDevice = (id,data) => {
  return {
    type: actionTypes.SET_USER_DEVICE_DEV_MODE,
    id,
    data
  };
};

export const devModeUserDeviceSuccess = () => {
  return {
    type: actionTypes.SET_USER_DEVICE_DEV_MODE_SUCCESS
  };
};

export const devModeUserDeviceFail = () => {
  return {
    type: actionTypes.SET_USER_DEVICE_DEV_MODE_FAIL
  };
};

/* ===== USER CREDIT TERM REQEUST LIS ===== */
export const loadUserCreditTermRequestList = data => {
  return {
    type: actionTypes.LOAD_USER_CREDIT_TERM_REQEUST_LIST,
    data
  };
};

export const loadUserCreditTermRequestListSuccess = data => {
  return {
    type: actionTypes.LOAD_USER_CREDIT_TERM_REQEUST_LIST_SUCCESS,
    data
  };
};

export const loadUserCreditTermRequestListFail = () => {
  return {
    type: actionTypes.LOAD_USER_CREDIT_TERM_REQEUST_LIST_FAIL
  };
};




export const approveUserCreditTerm = (id, data) => {
  return {
    type: actionTypes.APPROVE_USER_CREDIT_TERM_REQEUST,
    id, 
    data
  };
};

export const approveUserCreditTermSuccess = () => {
  return {
    type: actionTypes.APPROVE_USER_CREDIT_TERM_REQEUST_SUCCESS
  };
};

export const approveUserCreditTermFail = () => {
  return {
    type: actionTypes.APPROVE_USER_CREDIT_TERM_REQEUST_FAIL
  };
};



export const rejectUserCreditTerm = (id,data) => {
  return {
    type: actionTypes.REJECT_USER_CREDIT_TERM_REQEUST,
    id,
    data
  };
};

export const rejectUserCreditTermSuccess = () => {
  return {
    type: actionTypes.REJECT_USER_CREDIT_TERM_REQEUST_SUCCESS
  };
};

export const rejectUserCreditTermFail = () => {
  return {
    type: actionTypes.REJECT_USER_CREDIT_TERM_REQEUST_FAIL
  };
};


export const cancelUserCreditTerm = (id,data) => {
  return {
    type: actionTypes.CANCEL_USER_CREDIT_TERM_REQEUST,
    id,
    data
  };
};

export const cancelUserCreditTermSuccess = () => {
  return {
    type: actionTypes.CANCEL_USER_CREDIT_TERM_REQEUST_SUCCESS
  };
};

export const cancelUserCreditTermFail = () => {
  return {
    type: actionTypes.CANCEL_USER_CREDIT_TERM_REQEUST_FAIL
  };
};

/* ===== END USER CREDIT TERM REQEUST LIS ===== */



export const setUserNegoPrice = (id, data) => {
  return {
    type: actionTypes.SET_USER_NEGO_PRICE,
    id,
    data
  };
};

export const setUserNegoPriceSuccess = () => {
  return {
    type: actionTypes.SET_USER_NEGO_PRICE_SUCCESS
  };
};

export const setUserNegoPriceFail = () => {
  return {
    type: actionTypes.SET_USER_NEGO_PRICE_FAIL
  };
};



export const setQuotationState = (id, data) => {
  return {
    type: actionTypes.SET_QUOTATION_STATE,
    id, 
    data
  };
};

export const setQuotationStateSuccess = () => {
  return {
    type: actionTypes.SET_QUOTATION_STATE_SUCCESS
  };
};

export const setQuotationStateFail = () => {
  return {
    type: actionTypes.SET_QUOTATION_STATE_FAIL
  };
};



export const countPendingEInvoiceWalletVerifed = (data) => {
  return {
    type: actionTypes.COUNT_PENDING_EINVOICE_WALLET_VERIFIED,
    data
  };
};

export const countPendingEInvoiceWalletVerifedSuccess = (data) => {
  return {
    type: actionTypes.COUNT_PENDING_EINVOICE_WALLET_VERIFIED_SUCCESS,
    data
  };
};

export const countPendingEInvoiceWalletVerifedFail = () => {
  return {
    type: actionTypes.COUNT_PENDING_EINVOICE_WALLET_VERIFIED_FAIL
  };
};


export const processPendingEInvoiceWalletVerifed = (data) => {
  return {
    type: actionTypes.PROCESS_PENDING_EINVOICE_WALLET_VERIFIED,
    data
  };
};

export const processPendingEInvoiceWalletVerifedSuccess = () => {
  return {
    type: actionTypes.PROCESS_PENDING_EINVOICE_WALLET_VERIFIED_SUCCESS
  };
};

export const processPendingEInvoiceWalletVerifedFail = () => {
  return {
    type: actionTypes.PROCESS_PENDING_EINVOICE_WALLET_VERIFIED_FAIL
  };
};



export const updateWalletEInvoice = (id, data) => {
  return {
    type: actionTypes.UPDATE_WALLET_EINVOICE,
    id,
    data
  };
};

export const updateWalletEInvoiceSuccess = () => {
  return {
    type: actionTypes.UPDATE_WALLET_EINVOICE_SUCCESS
  };
};

export const updateWalletEInvoiceFail = () => {
  return {
    type: actionTypes.UPDATE_WALLET_EINVOICE_FAIL
  };
};

export const editUserEduRanking = (id, data, listParams) => {
  return {
    type: actionTypes.EDIT_USER_EDU_RANKING,
    id,
    data,
    listParams
  };
};

export const editUserEduRankingSuccess = () => {
  return {
    type: actionTypes.EDIT_USER_EDU_RANKING_SUCCESS
  };
};

export const editUserEduRankingFail = () => {
  return {
    type: actionTypes.EDIT_USER_EDU_RANKING_FAIL
  };
};


export const editUserExcludeRanking = (id, data, listParams) => {
  return {
    type: actionTypes.EDIT_USER_EXCLUDE_RANKING,
    id,
    data,
    listParams
  };
};

export const editUserExcludeRankingSuccess = () => {
  return {
    type: actionTypes.EDIT_USER_EXCLUDE_RANKING_SUCCESS
  };
};

export const editUserExcludeRankingFail = () => {
  return {
    type: actionTypes.EDIT_USER_EXCLUDE_RANKING_FAIL
  };
};


export const excelUpdateUserEInvoiceTIN = (data) => {
  return {
    type: actionTypes.EXCEL_UPDATE_USER_TIN,
    data
  };
};

export const excelUpdateUserEInvoiceTINSuccess = () => {
  return {
    type: actionTypes.EXCEL_UPDATE_USER_TIN_SUCCESS
  };
};

export const excelUpdateUserEInvoiceTINFail = () => {
  return {
    type: actionTypes.EXCEL_UPDATE_USER_TIN_FAIL
  };
};
